var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"upload-statistics"}},[_c('div',{staticClass:"uploaded-list-container"},[_c('div',{staticClass:"uploaded-table"},[_c(_vm.activeComponent,{tag:"component",attrs:{"activeRoster":_vm.activeRoster,"showSourceId":_vm.showSourceId}},[_c('div',[_vm._v(_vm._s(_vm.activeRoster)+"\n            ")])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }